import React, { useState } from 'react';
import styled from 'styled-components';
import { motion, AnimatePresence } from 'framer-motion';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGithub, faLinkedin } from '@fortawesome/free-brands-svg-icons';
import { faBars, faTimes } from '@fortawesome/free-solid-svg-icons';

const HeaderContainer = styled.header`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  padding: 1.2rem 2rem;
  background: ${(props) => props.theme.colors.white};
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.27);
  z-index: 1001;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Logo = styled(motion.h1)`
  color: ${(props) => props.theme.colors.secondary};
  margin: 0;
  font-size: 1.5rem;
  cursor: pointer;
`;

const Nav = styled.nav<{ $isOpen: boolean }>`
  display: flex;
  align-items: center;
  gap: 2rem;

  @media (max-width: ${(props) => props.theme.breakpoints.tablet}) {
    position: fixed;
    top: 0;
    right: ${(props) => (props.$isOpen ? '0' : '-100%')};
    height: 100vh;
    width: 250px;
    background: ${(props) => props.theme.colors.white};
    flex-direction: column;
    padding: 5rem 2rem;
    transition: right 0.3s ease;
    box-shadow: -2px 0 10px rgba(0, 0, 0, 0.1);
  }
`;

const NavLink = styled(motion.a)`
  color: ${(props) => props.theme.colors.gray.dark};
  text-decoration: none;
  font-weight: 500;
  transition: color 0.3s ease;

  &:hover {
    color: ${(props) => props.theme.colors.primary};
  }
`;

const SocialLinks = styled.div`
  display: flex;
  gap: 1rem;

  @media (max-width: ${(props) => props.theme.breakpoints.tablet}) {
    margin-top: 2rem;
  }
`;

const SocialLink = styled(motion.a)`
  color: ${(props) => props.theme.colors.secondary};
  font-size: 1.2rem;
  transition: color 0.3s ease;

  &:hover {
    color: ${(props) => props.theme.colors.primary};
  }
`;

const MenuButton = styled(motion.button)`
  display: none;
  background: none;
  border: none;
  color: ${(props) => props.theme.colors.secondary};
  font-size: 1.5rem;
  cursor: pointer;
  z-index: 1001;

  @media (max-width: ${(props) => props.theme.breakpoints.tablet}) {
    display: block;
  }
`;

const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <HeaderContainer>
      <Logo
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        onClick={() => (window.location.href = '#home')}
      >
        <img
          src={`/img/logo.svg`}
          alt='Zara Zamanian personal Logo'
          style={{
            width: '40px',
            height: '40px',
            marginRight: '1rem',
            display: 'inline-block',
            verticalAlign: 'middle',
          }}
        />
        Zara Zamanian
      </Logo>

      <MenuButton onClick={toggleMenu} whileTap={{ scale: 0.95 }}>
        <FontAwesomeIcon icon={isMenuOpen ? faTimes : faBars} />
      </MenuButton>

      <Nav $isOpen={isMenuOpen}>
        <NavLink
          href='#home'
          onClick={closeMenu}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          Home
        </NavLink>
        <NavLink
          href='#portfolio'
          onClick={closeMenu}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          Portfolio
        </NavLink>
        <NavLink
          href='#story'
          onClick={closeMenu}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          My Story
        </NavLink>
        {/* <NavLink
          href='#projects'
          onClick={closeMenu}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          Projects
        </NavLink> */}
        <NavLink
          href='#contact'
          onClick={closeMenu}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          Contact
        </NavLink>

        <SocialLinks>
          <SocialLink
            href='https://github.com/zaaraa-z'
            target='_blank'
            rel='noopener noreferrer'
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
          >
            <FontAwesomeIcon icon={faGithub} />
          </SocialLink>
          <SocialLink
            href='https://linkedin.com/in/zahra-zamanian'
            target='_blank'
            rel='noopener noreferrer'
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
          >
            <FontAwesomeIcon icon={faLinkedin} />
          </SocialLink>
        </SocialLinks>
      </Nav>
    </HeaderContainer>
  );
};

export default Header;
